import React from 'react';

/**
 * Landing pública del visor (viewer.ipse.com.ec /).
 *
 * El visor ya no muestra la worklist en la raíz. Esta página explica el acceso
 * seguro y lleva al PACS o al sitio de IPSE; los estudios se abren SOLO con un
 * enlace autorizado (/viewer?...&token=...).
 */
export default function Landing() {
  const backend =
    (window as any)?.config?.customConfig?.backendUrl || 'https://pacs.ipse.com.ec';
  const pacsUrl = String(backend).replace(/\/+$/, '');
  const base = ((window as any).PUBLIC_URL || '/').replace(/\/+$/, '');
  const logo = `${base}/assets/ipse_blanco.png`;
  const pacsLogo = `${base}/assets/ipse_pacs_blanco.png`;

  const botonPrimario: React.CSSProperties = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    padding: '12px 20px',
    borderRadius: 12,
    background: '#ffffff',
    color: '#003071',
    fontWeight: 700,
    fontSize: 14,
    textDecoration: 'none',
    boxShadow: '0 10px 30px rgba(0,0,0,0.25)',
  };
  const botonSecundario: React.CSSProperties = {
    ...botonPrimario,
    background: 'rgba(255,255,255,0.10)',
    color: '#ffffff',
    border: '1px solid rgba(255,255,255,0.28)',
    boxShadow: 'none',
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        color: '#ffffff',
        background:
          'radial-gradient(900px 500px at 15% 10%, rgba(0,86,173,0.55), transparent 60%), ' +
          'radial-gradient(800px 500px at 90% 90%, rgba(0,48,113,0.75), transparent 60%), ' +
          'linear-gradient(135deg, #010624 0%, #003071 100%)',
        fontFamily:
          'Inter, ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 520,
          padding: '36px 34px 30px',
          borderRadius: 24,
          background: 'rgba(255,255,255,0.07)',
          border: '1px solid rgba(255,255,255,0.14)',
          boxShadow: '0 30px 90px rgba(0,0,0,0.42)',
          backdropFilter: 'blur(14px)',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 14,
            marginBottom: 26,
          }}
        >
          <img
            src={pacsLogo}
            alt="IPSE PACS"
            style={{ height: 40, maxWidth: 210, objectFit: 'contain' }}
            onError={e => {
              (e.target as HTMLImageElement).style.display = 'none';
            }}
          />
          <span
            aria-hidden="true"
            style={{
              width: 1,
              height: 34,
              background: 'rgba(255,255,255,0.22)',
              display: 'inline-block',
            }}
          />
          <img
            src={logo}
            alt="IPSE"
            style={{ height: 35, maxWidth: 170, objectFit: 'contain' }}
            onError={e => {
              (e.target as HTMLImageElement).style.display = 'none';
            }}
          />
        </div>

        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 7,
            padding: '5px 10px',
            borderRadius: 999,
            background: 'rgba(255,255,255,0.10)',
            border: '1px solid rgba(255,255,255,0.16)',
            fontSize: 11,
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            color: '#cfe0ff',
            marginBottom: 14,
          }}
        >
          <span style={{ width: 7, height: 7, borderRadius: 999, background: '#6ee7b7' }} />
          Acceso seguro
        </div>

        <h1 style={{ fontSize: 28, lineHeight: 1.15, margin: '0 0 10px', fontWeight: 800 }}>
          Visor de imágenes médicas
        </h1>
        <p style={{ margin: '0 0 24px', color: '#d7e3f5', fontSize: 14, lineHeight: 1.6 }}>
          El visor se abre únicamente con un <strong>enlace autorizado</strong> generado
          desde el PACS o enviado por su médico. Si ya tiene su enlace, ábralo directamente.
        </p>

        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          <a href={pacsUrl} style={botonPrimario}>
            Ir al PACS
            <span aria-hidden="true">→</span>
          </a>
          <a
            href="https://ipse.com.ec"
            target="_blank"
            rel="noreferrer"
            style={botonSecundario}
          >
            Sitio de IPSE
          </a>
        </div>

        <p
          style={{
            margin: '26px 0 0',
            paddingTop: 16,
            borderTop: '1px solid rgba(255,255,255,0.12)',
            color: '#9fb3d1',
            fontSize: 11,
            lineHeight: 1.5,
          }}
        >
          © 2026 IPSE S.A. · Todos los derechos reservados
          <br />
          Acceso exclusivo mediante enlaces seguros del PACS.
        </p>
      </div>
    </div>
  );
}
